export default __webpack_public_path__ + "static/media/library-section-01.a7519559.png";